module.exports = __webpack_public_path__ + "img/UKaccent.7c9ccdbf.svg";